/**
 * Placeholder dashboard page.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import MoodBad from '@material-ui/icons/MoodBad';
import Mood from '@material-ui/icons/Mood';
import LockOpen from '@material-ui/icons/LockOpen';
import MailOutline from '@material-ui/icons/MailOutline';
import Group from '@material-ui/icons/Group';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { withStyles } from '@material-ui/styles';

import { OWNER } from 'constants/roles';
import AuthorizedContainer from '../../Authorized/AuthorizedContainer';

const propTypes = {
  classes: PropTypes.shape({
    header: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    card: PropTypes.string.isRequired,
    cardHeader: PropTypes.string.isRequired,
    legend: PropTypes.string.isRequired,
    legendIcon: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    organizationId: PropTypes.string.isRequired,
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  accessToken: PropTypes.string.isRequired,
};

export function UnstyledDashboardPage({ user, accessToken, classes }) {
  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <Typography className={classes.header} variant="h4" align="center">
          Welcome, <span className={classes.name}>{user.name}</span>!
        </Typography>
      </Grid>
      <Grid item md={1} sm={false} />
      <Grid item md={10} sm={12} className={classes.content}>
        <Card className={classes.card}>
          <CardHeader
            title="Email"
            titleTypographyProps={{ className: classes.cardHeader }}
            avatar={<MailOutline />}
          />
          <CardContent>{user.email}</CardContent>
        </Card>
        <Card className={classes.card}>
          <CardHeader
            title="Organization Id"
            titleTypographyProps={{ className: classes.cardHeader }}
            avatar={<Group />}
          />
          <CardContent>{user.organizationId}</CardContent>
        </Card>
        <Card className={classes.card}>
          <CardHeader
            title="Permissions"
            titleTypographyProps={{ className: classes.cardHeader }}
            avatar={<AccountCircle />}
          />
          <CardContent>
            <List>
              {user.permissions.map((perm) => (
                <ListItem key={perm}>{perm}</ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
        <Card className={classes.card}>
          <CardHeader
            title="Roles"
            titleTypographyProps={{ className: classes.cardHeader }}
            avatar={<AccountCircle />}
          />
          <CardContent>
            <List>
              {user.roles.map((role) => (
                <ListItem key={role}>{role}</ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
        <Card className={classes.card}>
          <CardHeader
            title="Roles Demo"
            titleTypographyProps={{ className: classes.cardHeader }}
            avatar={<AccountCircle />}
          />
          <CardContent>
            <legend className={classes.legend}>
              <div>
                <Mood className={classes.legendIcon} />= owner
              </div>
              <div>
                <MoodBad className={classes.legendIcon} />= not an owner
              </div>
            </legend>
            <Typography variant="subtitle1">Your role:</Typography>
            <AuthorizedContainer roles={[OWNER]}>
              <Mood className={classes.icon} />
            </AuthorizedContainer>
            <AuthorizedContainer roles={[OWNER]} show={false}>
              <MoodBad className={classes.icon} />
            </AuthorizedContainer>
          </CardContent>
        </Card>
        <Card className={classes.card}>
          <CardHeader
            title="Access Token"
            titleTypographyProps={{ className: classes.cardHeader }}
            avatar={<LockOpen />}
          />
          <CardContent className={classes.token}>{accessToken}</CardContent>
        </Card>
      </Grid>
      <Grid item md={1} sm={false} />
    </Grid>
  );
}

UnstyledDashboardPage.propTypes = propTypes;

const styles = (theme) => ({
  header: {
    marginTop: theme.spacing(4),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  name: {
    color: theme.customColors.orange,
  },
  icon: {
    margin: '0 auto',
    display: 'block',
    fontSize: '5rem',
  },
  legend: {
    marginBottom: theme.spacing(1),
  },
  legendIcon: {
    fontSize: '1.5rem',
    marginRight: theme.spacing(1),
  },
  card: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.customColors.white,
    display: 'inline-block',
    maxWidth: '50%',
    verticalAlign: 'top',
    wordWrap: 'break-word',
    fontSize: '.8rem',
  },
  cardHeader: {
    color: theme.customColors.darkGrey,
  },
  token: {
    fontSize: '.5em',
  },
});

export default withStyles(styles)(UnstyledDashboardPage);
